// actionsTypes
//Single Product
export const GET_SINGLE_PRODUCT_REQUEST = "GET_SINGLE_PRODUCT_REQUEST";
export const GET_SINGLE_PRODUCT_SUCCESS = "GET_SINGLE_PRODUCT_SUCCESS";
export const GET_SINGLE_PRODUCT_ERROR = "GET_SINGLE_PRODUCT_ERROR";

//Get Cart
export const GET_CART_REQUEST = "GET_CART_REQUEST";
export const GET_CART_SUCCESS = "GET_CART_SUCCESS";
export const GET_CART_ERROR = "GET_CART_ERROR";

//AddToCart
export const ADD_TO_CART_REQUEST = "ADD_TO_CART_REQUEST";
export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";
export const ADD_TO_CART_ERROR = "ADD_TO_CART_ERROR";

//SimilarProducts
export const GET_SIMILAR_PRODUCTS_REQUEST = "GET_SIMILAR_PRODUCTS_REQUEST";
export const GET_SIMILAR_PRODUCTS_SUCCESS = "GET_SIMILAR_PRODUCTS_SUCCESS";
export const GET_SIMILAR_PRODUCTS_ERROR = "GET_SIMILAR_PRODUCTS_ERROR";

//Frequently Bought Together
export const GET_FREQUENTLY_BOUGHT_TOGETHER_REQUEST =
  "GET_FREQUENTLY_BOUGHT_TOGETHER_REQUEST";
export const GET_FREQUENTLY_BOUGHT_TOGETHER_SUCCESS =
  "GET_FREQUENTLY_BOUGHT_TOGETHER_SUCCESS";
export const GET_FREQUENTLY_BOUGHT_TOGETHER_ERROR =
  "GET_FREQUENTLY_BOUGHT_TOGETHER_ERROR";

export const FETCH_CART_ITEMS = "FETCH_CART_ITEMS";

// Create Order
export const CREATE_ORDER_REQUEST = "CREATE_ORDER_REQUEST";
export const CREATE_ORDER_SUCCESS = "CREATE_ORDER_SUCCESS";
export const CREATE_ORDER_ERROR = "CREATE_ORDER_ERROR";

// GET_ORDER_LIST_REQUEST
export const GET_ORDER_LIST_REQUEST = "GET_ORDER_LIST_REQUEST";
export const GET_ORDER_LIST_SUCCESS = "GET_ORDER_LIST_SUCCESS";
export const GET_ORDER_LIST_ERROR = "GET_ORDER_LIST_ERROR";

// GET_ORDER_BY_ID_REQUEST
export const GET_ORDER_BY_ID_REQUEST = "GET_ORDER_BY_ID_REQUEST";
export const GET_ORDER_BY_ID_SUCCESS = "GET_ORDER_BY_ID_SUCCESS";
export const GET_ORDER_BY_ID_ERROR = "GET_ORDER_BY_ID_ERROR";

// GET_USER_PROFILE
export const GET_USER_PROFILE_REQUEST = "GET_USER_PROFILE_REQUEST";
export const GET_USER_PROFILE_SUCCESS = "GET_USER_PROFILE_SUCCESS";
export const GET_USER_PROFILE_ERROR = "GET_USER_PROFILE_ERROR";

// REMOVE_FROM_CART
export const REMOVE_FROM_CART_REQUEST = "REMOVE_FROM_CART_REQUEST";
export const REMOVE_FROM_CART_SUCCESS = "REMOVE_FROM_CART_SUCCESS";
export const REMOVE_FROM_CART_ERROR = "REMOVE_FROM_CART_ERROR";

// ADD_ITEM_REQUEST from Cart
export const DELETE_ITEM_REQUEST = "DELETE_CART_ITEM_REQUEST";
export const DELETE_ITEM_SUCCESS = "DELETE_CART_ITEM_SUCCESS";
export const DELETE_ITEM_ERROR = "DELETE_CART_ITEM_ERROR";

// do Payment
export const POST_PAYMENT_REQUEST = "POST_PAYMENT_REQUEST";
export const POST_PAYMENT_SUCCESS = "POST_PAYMENT_SUCCESS";
export const POST_PAYMENT_FAILURE = "POST_PAYMENT_FAILURE";

// GET_USER_ADDRESS_BY_ID_REQUEST
export const GET_USER_ADDRESS_BY_ID_REQUEST = "GET_USER_ADDRESS_BY_ID_REQUEST";
export const GET_USER_ADDRESS_BY_ID_SUCCESS = "GET_USER_ADDRESS_BY_ID_SUCCESS";
export const GET_USER_ADDRESS_BY_ID_ERROR = "GET_USER_ADDRESS_BY_ID_ERROR";

//UPDATE_QUANTITY
export const UPDATE_QUANTITY = "UPDATE_QUANTITY";

// UPDATE_CART
export const UPDATE_CART = "UPDATE_CART";

// UPDATE_IS_IN_CART
export const UPDATE_IS_IN_CART = "UPDATE_IS_IN_CART";

// FETCH_LATEST_CART
export const FETCH_LATEST_CART = "FETCH_LATEST_CART";

// GET_SUGGESTED_PRODUCTS
export const GET_SUGGESTED_PRODUCTS_REQUEST = "GET_SUGGESTED_PRODUCTS_REQUEST";
export const GET_SUGGESTED_PRODUCTS_SUCCESS = "GET_SUGGESTED_PRODUCTS_SUCCESS";
export const GET_SUGGESTED_PRODUCTS_ERROR = "GET_SUGGESTED_PRODUCTS_ERROR";

// add address
export const ADD_ADDRESS_REQUEST = "ADD_ADDRESS_REQUEST";
export const ADD_ADDRESS_SUCCESS = "ADD_ADDRESS_SUCCESS";
export const ADD_ADDRESS_FAILURE = "ADD_ADDRESS_FAILURE";

// get all wishlist
export const GET_ALL_WISHLIST_PRODUCT_REQUEST =
  "GET_ALL_WISHLIST_PRODUCT_REQUEST";
export const GET_ALL_WISHLIST_PRODUCT_SUCCESS =
  "GET_ALL_WISHLIST_PRODUCT_SUCCESS";
export const GET_ALL_WISHLIST_PRODUCT_ERROR = "GET_ALL_WISHLIST_PRODUCT_ERROR";

// Aipowered
export const FETCH_WISHLIST_SUGGESTIONS_REQUEST =
  "FETCH_WISHLIST_SUGGESTIONS_REQUEST";
export const FETCH_WISHLIST_SUGGESTIONS_SUCCESS =
  "FETCH_WISHLIST_SUGGESTIONS_SUCCESS";
export const FETCH_WISHLIST_SUGGESTIONS_ERROR =
  "FETCH_WISHLIST_SUGGESTIONS_ERROR";

//  FETCH_AIGIFTS_REQUEST
export const FETCH_AIGIFTS_REQUEST = "FETCH_AIGIFTS_REQUEST";
export const FETCH_AIGIFTS_SUCCESS = "FETCH_AIGIFTS_SUCCESS";
export const FETCH_AIGIFTS_ERROR = "FETCH_AIGIFTS_ERROR";

//  FETCH_AIGIFTS_REQUEST
export const GET_ALL_CATEGORY_REQUEST = "GET_ALL_CATEGORY_REQUEST";
export const GET_ALL_CATEGORY_SUCCESS = "GET_ALL_CATEGORY_SUCCESS";
export const GET_ALL_CATEGORY_ERROR = "GET_ALL_CATEGORY_ERROR";

//  GET ALL TRENDING PRODUCTS
export const GET_ALL_TRENDING_PRODUCT_REQUEST =
  "GET_ALL_TRENDING_PRODUCT_REQUEST";
export const GET_ALL_TRENDING_PRODUCT_SUCCESS =
  "GET_ALL_TRENDING_PRODUCT_SUCCESS";
export const GET_ALL_TRENDING_PRODUCT_ERROR = "GET_ALL_TRENDING_PRODUCT_ERROR";

// greetingssubcategory

export const GET_SUBCATEGORY_REQUEST = "GET_SUBCATEGORY_REQUEST";
export const GET_SUBCATEGORY_SUCCESS = "GET_SUBCATEGORY_SUCCESS";
export const GET_SUBCATEGORY_ERROR = "GET_SUBCATEGORY_ERROR";

// notify request

export const SEND_NOTIFY_REQUEST = "SEND_NOTIFY_REQUEST";
export const SEND_NOTIFY_SUCCESS = "SEND_NOTIFY_SUCCESS";
export const SEND_NOTIFY_ERROR = "SEND_NOTIFY_ERROR";

// notify request

export const CHECK_PIN_CODE_AVAILABILITY_REQUEST =
  "CHECK_PIN_CODE_AVAILABILITY_REQUEST";
export const CHECK_PIN_CODE_AVAILABILITY_SUCCESS =
  "CHECK_PIN_CODE_AVAILABILITY_SUCCESS";
export const CHECK_PIN_CODE_AVAILABILITY_ERROR =
  "CHECK_PIN_CODE_AVAILABILITY_ERROR";
export const EMPTY_PIN_CODE_AVAILABILITY = "EMPTY_PIN_CODE_AVAILABILITY";

// get plnat by sub category
export const GET_SUB_CATEGORY_PLANTS_REQUEST =
  "GET_SUB_CATEGORY_PLANTS_REQUEST";
export const GET_SUB_CATEGORY_PLANTS_SUCCESS =
  "GET_SUB_CATEGORY_PLANTS_SUCCESS";
export const GET_SUB_CATEGORY_PLANTS_ERROR = "GET_SUB_CATEGORY_PLANTS_ERROR";
